import { useContext } from "react";
import "./style.scss"
import { AuthContext } from "../../../context/auth";
import { proteinNameNormalize } from "../../../utils/proteinNameNormalize";
import { downloadPdf } from "../../../utils/downloader";

const Index = ({ setSelectedProtein, selectedProtein, proteinFunctions, pathway = 'ssb' }) => {
  const { setNotification } = useContext(AuthContext)

  return (
    <>
      <div className="header">
        <h2>Anti-Human {selectedProtein}</h2>
        <div className="icons-container"
          onClick={() => {
            setSelectedProtein(null)
          }}
        >
          <i className='fal fa-times'></i>
        </div>
      </div>
      <div className="mobile-overflow watermark">
        <p className="function-text" dangerouslySetInnerHTML={{ __html: proteinFunctions.find((item) => item.name === selectedProtein)?.function || '-' }} />
        <div className="references">
          <h4>References:</h4>
          <div className="references-list">
            {proteinFunctions?.find((item) => item.name === selectedProtein)?.reference.filter((item) => item !== "").map((item, index) => {
              return <a href={item.includes("https") ? item : `https://${item}`} target="_blank" key={index}>[{index + 1}]</a>
            })}
          </div>
        </div>
        <p className="function-text"><br />© Copyright 2026 GMD12 LLC.</p>
      </div>
      <div className='share-btn-container'>
        <button className='btn share-btn' onClick={() => {
          navigator.clipboard.writeText(`https://content.identifyn.com/proteins/${pathway}_${proteinNameNormalize(selectedProtein)}.pdf`)
          setNotification({ type: "success", message: "Link copied" })
        }}><i className='fal fa-share-alt'></i> Share</button>
        <button className='btn' onClick={() => {
          downloadPdf(`https://content.identifyn.com/proteins/${pathway}_${proteinNameNormalize(selectedProtein)}.pdf`, `${pathway}_${proteinNameNormalize(selectedProtein)}.pdf`)
        }}><i className="fal fa-download"></i>Download PDF</button>
      </div>
    </>
  )
}

export default Index